module.exports = __webpack_public_path__ + "img/p_sz_8.cd05472b.svg";